export interface TreeElement<T, TE extends TreeElement<T, TE>> {
    item: T;
    parent: TE | null;
    children: TE[];
    get id(): number;
    get html(): string;
    get searchableText(): string;
}

export class FilteredTreeElement<T, TE extends TreeElement<T, TE>, TFTE extends FilteredTreeElement<T, TE, TFTE>> implements TreeElement<TE, TFTE> {
    item: TE;
    parent: TFTE | null;
    children: TFTE[] = [];
    visible: boolean = true;

    get id(): number {
        return this.item.id;
    }

    get html(): string {
        return this.item.html;
    }
    
    get searchableText(): string {
        return this.item.searchableText;
    }

    constructor(item: TE, parent: TFTE | null) {
        this.item = item;
        this.parent = parent;
        this.children = item.children.map(e => new FilteredTreeElement<T,TE,TFTE>(e, this as unknown as TFTE) as TFTE);
    }
}